module.exports = __webpack_public_path__ + "img/6-ilpakamanioMAS_thumb.324689a8.jpg";